var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useCallback, useEffect, useMemo, useRef, useState, } from "react";
import { useIntl } from "react-intl";
import { useCallout } from "@folio/stripes/core";
import { Accordion, AccordionSet, Button, ConfirmationModal, Icon, Label, Loading, MessageBanner, Modal, ModalFooter, Select, TextField, Tooltip, } from "@folio/stripes/components";
import { RichTextEditor } from "../inputs/RichTextEditor";
import { sanitizeHtml } from "../../utils/sanitizeHtml";
import { copyToClipboard } from "../../utils/clipboard";
import { hasHttpResponse } from "../../utils/apiUtils";
import { useLibraryMessageTemplates } from "../../hooks/useLibraryMessageTemplates";
import { useEditNavigation } from "../../utils/listReturn";
import { libraryEdit } from "../../types/routePaths";
import { useMessageTemplatePreview, useResetMessageTemplate, useSaveMessageTemplate, } from "../../hooks/useMessageTemplateMutations";
import { MESSAGE_TEMPLATE_TYPES, MESSAGE_TEMPLATE_TYPE_LABEL_IDS, } from "../../types/messageTemplate";
import { findOnlyCustomVariant, findPlaceholderDescriptionId, findUsedEmptyPlaceholders, placeholderToken, } from "../../utils/messageTemplateWarnings";
import { EMPTY_CHIP_HINT_IDS, EmptyPlaceholderBanners, EmptyPlaceholdersPreviewNote, HighlightedPreviewSubject, OnlyCustomVariantBanner, VariantAccordionLabel, VariantInfoNote, } from "./MessageTemplateWarnings";
import styles from "./LibraryEmailTemplatesDialog.module.css";
var NO_EMPTY_PLACEHOLDERS = [];
var NO_PLACEHOLDERS = [];
var extractErrorMessage = function (error) { return __awaiter(void 0, void 0, void 0, function () {
    var body, _a;
    var _b, _c, _d;
    return __generator(this, function (_e) {
        switch (_e.label) {
            case 0:
                if (!hasHttpResponse(error))
                    return [2 /*return*/, null];
                _e.label = 1;
            case 1:
                _e.trys.push([1, 3, , 4]);
                return [4 /*yield*/, error.response.json()];
            case 2:
                body = _e.sent();
                return [2 /*return*/, (_d = (_c = (_b = body === null || body === void 0 ? void 0 : body.errors) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.message) !== null && _d !== void 0 ? _d : null];
            case 3:
                _a = _e.sent();
                return [2 /*return*/, null];
            case 4: return [2 /*return*/];
        }
    });
}); };
var PlaceholderChip = function (_a) {
    var token = _a.token, description = _a.description, copyLabel = _a.copyLabel, copiedLabel = _a.copiedLabel, emptyHint = _a.emptyHint;
    var _b = useState(false), copied = _b[0], setCopied = _b[1];
    var timeoutRef = useRef();
    var wrapRef = useRef(null);
    var triggerRef = useRef(null);
    useEffect(function () { return function () {
        if (timeoutRef.current)
            clearTimeout(timeoutRef.current);
    }; }, []);
    var handleCopy = useCallback(function () {
        var _a;
        copyToClipboard("{".concat(token, "}"), (_a = wrapRef.current) !== null && _a !== void 0 ? _a : document.body);
        setCopied(true);
        if (timeoutRef.current)
            clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(function () { return setCopied(false); }, 1500);
    }, [token]);
    var renderChip = function (_a) {
        var ariaIds = _a.ariaIds;
        return (React.createElement("span", { className: styles.chip, ref: wrapRef, "data-empty-placeholder": emptyHint ? token : undefined },
            React.createElement(Button, { ref: triggerRef, buttonStyle: "none", buttonClass: emptyHint
                    ? "".concat(styles.chipButton, " ").concat(styles.chipButtonEmpty)
                    : styles.chipButton, marginBottom0: true, onClick: handleCopy, "aria-labelledby": "".concat(ariaIds.text, " ").concat(ariaIds.sub) },
                emptyHint && (React.createElement(Icon, { icon: "exclamation-circle", size: "small", status: "warn", iconClassName: styles.chipWarningIcon })), "{".concat(token, "}")),
            copied && (React.createElement("span", { className: styles.copiedToast, role: "status" }, copiedLabel))));
    };
    return (React.createElement(Tooltip, { id: "placeholder-tooltip-".concat(token), text: emptyHint ? "".concat(description, ". ").concat(emptyHint) : description, sub: copyLabel, placement: "bottom", triggerRef: triggerRef }, renderChip));
};
var VariantEditor = function (_a) {
    var _b, _c, _d, _e;
    var accordionId = _a.accordionId, accordionLabel = _a.accordionLabel, subjectLabel = _a.subjectLabel, bodyLabel = _a.bodyLabel, subject = _a.subject, body = _a.body, onSubjectChange = _a.onSubjectChange, onBodyChange = _a.onBodyChange, onPreview = _a.onPreview, onHidePreview = _a.onHidePreview, previewLabel = _a.previewLabel, hidePreviewLabel = _a.hidePreviewLabel, isPreviewLoading = _a.isPreviewLoading, previewResult = _a.previewResult, previewError = _a.previewError, open = _a.open, onToggle = _a.onToggle;
    return (React.createElement(Accordion, { id: accordionId, label: accordionLabel, open: open, onToggle: onToggle },
        React.createElement(TextField, { label: subjectLabel, value: subject, onChange: function (e) {
                return onSubjectChange(e.target.value);
            }, required: true }),
        React.createElement(RichTextEditor, { id: "".concat(accordionId, "-body"), label: bodyLabel, value: body, onChange: onBodyChange, required: true }),
        React.createElement("div", { className: styles.previewSection },
            React.createElement("div", { className: styles.previewActions },
                React.createElement(Button, { onClick: onPreview, disabled: isPreviewLoading }, previewLabel),
                previewResult && (React.createElement(Button, { onClick: onHidePreview }, hidePreviewLabel))),
            previewError && (React.createElement(MessageBanner, { type: "error" }, previewError)),
            previewResult && (React.createElement("div", { className: styles.previewResult, "data-template-preview": true },
                ((_c = (_b = previewResult.emptyPlaceholders) === null || _b === void 0 ? void 0 : _b.length) !== null && _c !== void 0 ? _c : 0) > 0 && (React.createElement(EmptyPlaceholdersPreviewNote, { emptyPlaceholders: (_d = previewResult.emptyPlaceholders) !== null && _d !== void 0 ? _d : NO_EMPTY_PLACEHOLDERS })),
                React.createElement(HighlightedPreviewSubject, { className: styles.previewSubject, markClassName: styles.emptyMark, subject: previewResult.subject, emptyPlaceholders: (_e = previewResult.emptyPlaceholders) !== null && _e !== void 0 ? _e : NO_EMPTY_PLACEHOLDERS }),
                React.createElement("div", { className: styles.previewBody, dangerouslySetInnerHTML: {
                        __html: sanitizeHtml(previewResult.body),
                    } }))))));
};
var DISCARD_CONFIRM_TEXT_IDS = {
    switchType: {
        message: "ui-br-legaldeposits.libraries.messageTemplates.discard.confirm.message",
        button: "ui-br-legaldeposits.libraries.messageTemplates.discard.confirm.button",
    },
    openLibraryEdit: {
        message: "ui-br-legaldeposits.libraries.messageTemplates.discard.confirm.openLibraryEdit.message",
        button: "ui-br-legaldeposits.libraries.messageTemplates.discard.confirm.openLibraryEdit.button",
    },
};
var NOT_TOUCHED = { single: false, plural: false };
export var LibraryEmailTemplatesDialog = function (_a) {
    var _b, _c, _d, _e, _f;
    var open = _a.open, onClose = _a.onClose, libraryId = _a.libraryId, libraryName = _a.libraryName, selectedType = _a.selectedType, onSelectedTypeChange = _a.onSelectedTypeChange;
    var _g = useIntl(), formatMessage = _g.formatMessage, messages = _g.messages;
    var callout = useCallout();
    var navigateToEdit = useEditNavigation();
    var resolvedLibraryId = libraryId !== null && libraryId !== void 0 ? libraryId : "";
    var _h = useState(null), pendingDiscard = _h[0], setPendingDiscard = _h[1];
    var _j = useState(false), showResetConfirm = _j[0], setShowResetConfirm = _j[1];
    var _k = useState(null), saveErrorMessage = _k[0], setSaveErrorMessage = _k[1];
    var _l = useState(null), singlePreviewError = _l[0], setSinglePreviewError = _l[1];
    var _m = useState(null), pluralPreviewError = _m[0], setPluralPreviewError = _m[1];
    var _o = useState({
        single: true,
        plural: false,
    }), accordionOpen = _o[0], setAccordionOpen = _o[1];
    var _p = useState(NOT_TOUCHED), touched = _p[0], setTouched = _p[1];
    var _q = useState(""), singleSubject = _q[0], setSingleSubject = _q[1];
    var _r = useState(""), singleBody = _r[0], setSingleBody = _r[1];
    var _s = useState(""), pluralSubject = _s[0], setPluralSubject = _s[1];
    var _t = useState(""), pluralBody = _t[0], setPluralBody = _t[1];
    var templatesQuery = useLibraryMessageTemplates(libraryId, open);
    var saveMutation = useSaveMessageTemplate(resolvedLibraryId);
    var resetMutation = useResetMessageTemplate(resolvedLibraryId);
    var singlePreviewMutation = useMessageTemplatePreview(resolvedLibraryId);
    var pluralPreviewMutation = useMessageTemplatePreview(resolvedLibraryId);
    var currentTemplate = useMemo(function () {
        var _a, _b;
        return (_b = (_a = templatesQuery.data) === null || _a === void 0 ? void 0 : _a.templates.find(function (t) { return t.type === selectedType; })) !== null && _b !== void 0 ? _b : null;
    }, [templatesQuery.data, selectedType]);
    // fallback to true so an older backend without pluralUsed keeps both variants
    var pluralUsed = (currentTemplate === null || currentTemplate === void 0 ? void 0 : currentTemplate.pluralUsed) !== false;
    useEffect(function () {
        var _a, _b, _c, _d;
        setSingleSubject((_a = currentTemplate === null || currentTemplate === void 0 ? void 0 : currentTemplate.singleSubject) !== null && _a !== void 0 ? _a : "");
        setSingleBody((_b = currentTemplate === null || currentTemplate === void 0 ? void 0 : currentTemplate.singleBody) !== null && _b !== void 0 ? _b : "");
        setPluralSubject((_c = currentTemplate === null || currentTemplate === void 0 ? void 0 : currentTemplate.pluralSubject) !== null && _c !== void 0 ? _c : "");
        setPluralBody((_d = currentTemplate === null || currentTemplate === void 0 ? void 0 : currentTemplate.pluralBody) !== null && _d !== void 0 ? _d : "");
        setTouched(NOT_TOUCHED);
    }, [
        currentTemplate === null || currentTemplate === void 0 ? void 0 : currentTemplate.singleSubject,
        currentTemplate === null || currentTemplate === void 0 ? void 0 : currentTemplate.singleBody,
        currentTemplate === null || currentTemplate === void 0 ? void 0 : currentTemplate.pluralSubject,
        currentTemplate === null || currentTemplate === void 0 ? void 0 : currentTemplate.pluralBody,
    ]);
    useEffect(function () {
        if (!open) {
            setPendingDiscard(null);
            setShowResetConfirm(false);
            setSaveErrorMessage(null);
            setSinglePreviewError(null);
            setPluralPreviewError(null);
            setAccordionOpen({ single: true, plural: false });
            singlePreviewMutation.reset();
            pluralPreviewMutation.reset();
        }
        // preview mutation references change every render; resetting them is a close-only side effect
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open]);
    useEffect(function () {
        setSaveErrorMessage(null);
        setSinglePreviewError(null);
        setPluralPreviewError(null);
        singlePreviewMutation.reset();
        pluralPreviewMutation.reset();
        // preview mutation references change every render; resetting them is a type-switch-only side effect
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedType]);
    var emptyLibraryPlaceholders = (_c = (_b = templatesQuery.data) === null || _b === void 0 ? void 0 : _b.emptyLibraryPlaceholders) !== null && _c !== void 0 ? _c : NO_EMPTY_PLACEHOLDERS;
    var emptyHintByPlaceholder = useMemo(function () {
        return new Map(emptyLibraryPlaceholders.map(function (_a) {
            var placeholder = _a.placeholder, reason = _a.reason;
            return [
                placeholder,
                formatMessage({ id: EMPTY_CHIP_HINT_IDS[reason] }),
            ];
        }));
    }, [emptyLibraryPlaceholders, formatMessage]);
    var usedEmptyPlaceholders = useMemo(function () {
        return findUsedEmptyPlaceholders(emptyLibraryPlaceholders, pluralUsed
            ? [singleSubject, singleBody, pluralSubject, pluralBody]
            : [singleSubject, singleBody]);
    }, [
        emptyLibraryPlaceholders,
        pluralUsed,
        singleSubject,
        singleBody,
        pluralSubject,
        pluralBody,
    ]);
    var onlyCustomVariant = currentTemplate
        ? findOnlyCustomVariant(currentTemplate)
        : null;
    // a string compare would flag every load dirty: Quill re-serialises the loaded body without any user edit
    var isDirty = touched.single || (pluralUsed && touched.plural);
    var openLibraryEdit = useCallback(function () {
        if (libraryId)
            navigateToEdit(libraryEdit(libraryId));
    }, [libraryId, navigateToEdit]);
    var handleTypeSelect = useCallback(function (nextType) {
        if (nextType === selectedType)
            return;
        if (isDirty) {
            setPendingDiscard({ kind: "switchType", type: nextType });
        }
        else {
            onSelectedTypeChange(nextType);
        }
    }, [selectedType, isDirty, onSelectedTypeChange]);
    var handleOpenLibraryEdit = useCallback(function () {
        if (isDirty) {
            setPendingDiscard({ kind: "openLibraryEdit" });
        }
        else {
            openLibraryEdit();
        }
    }, [isDirty, openLibraryEdit]);
    var confirmDiscard = useCallback(function () {
        setPendingDiscard(null);
        if ((pendingDiscard === null || pendingDiscard === void 0 ? void 0 : pendingDiscard.kind) === "switchType") {
            onSelectedTypeChange(pendingDiscard.type);
        }
        else if ((pendingDiscard === null || pendingDiscard === void 0 ? void 0 : pendingDiscard.kind) === "openLibraryEdit") {
            openLibraryEdit();
        }
    }, [pendingDiscard, onSelectedTypeChange, openLibraryEdit]);
    var cancelDiscard = useCallback(function () { return setPendingDiscard(null); }, []);
    var markTouched = useCallback(function (variant) {
        setTouched(function (prev) {
            var _a;
            return (prev[variant] ? prev : __assign(__assign({}, prev), (_a = {}, _a[variant] = true, _a)));
        });
    }, []);
    var handleSingleSubjectChange = useCallback(function (value) {
        setSingleSubject(value);
        markTouched("single");
    }, [markTouched]);
    var handleSingleBodyChange = useCallback(function (value, origin) {
        setSingleBody(value);
        if (origin === "user")
            markTouched("single");
    }, [markTouched]);
    var handlePluralSubjectChange = useCallback(function (value) {
        setPluralSubject(value);
        markTouched("plural");
    }, [markTouched]);
    var handlePluralBodyChange = useCallback(function (value, origin) {
        setPluralBody(value);
        if (origin === "user")
            markTouched("plural");
    }, [markTouched]);
    var handleSave = useCallback(function () {
        var _a, _b, _c, _d;
        if (!libraryId)
            return;
        setSaveErrorMessage(null);
        // Quill re-serialises an untouched body; send it back byte-identical or it becomes the library's own text
        var single = touched.single
            ? { singleSubject: singleSubject, singleBody: singleBody }
            : {
                singleSubject: (_a = currentTemplate === null || currentTemplate === void 0 ? void 0 : currentTemplate.singleSubject) !== null && _a !== void 0 ? _a : singleSubject,
                singleBody: (_b = currentTemplate === null || currentTemplate === void 0 ? void 0 : currentTemplate.singleBody) !== null && _b !== void 0 ? _b : singleBody,
            };
        var plural = touched.plural
            ? { pluralSubject: pluralSubject, pluralBody: pluralBody }
            : {
                pluralSubject: (_c = currentTemplate === null || currentTemplate === void 0 ? void 0 : currentTemplate.pluralSubject) !== null && _c !== void 0 ? _c : pluralSubject,
                pluralBody: (_d = currentTemplate === null || currentTemplate === void 0 ? void 0 : currentTemplate.pluralBody) !== null && _d !== void 0 ? _d : pluralBody,
            };
        saveMutation.mutate({
            type: selectedType,
            payload: pluralUsed ? __assign(__assign({}, single), plural) : single,
        }, {
            onSuccess: function () {
                setTouched(NOT_TOUCHED);
                callout === null || callout === void 0 ? void 0 : callout.sendCallout({
                    type: "success",
                    message: formatMessage({
                        id: "ui-br-legaldeposits.libraries.messageTemplates.save.success",
                    }),
                });
            },
            onError: function (error) { return __awaiter(void 0, void 0, void 0, function () {
                var message;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, extractErrorMessage(error)];
                        case 1:
                            message = _a.sent();
                            setSaveErrorMessage(message !== null && message !== void 0 ? message : formatMessage({
                                id: "ui-br-legaldeposits.libraries.messageTemplates.save.error",
                            }));
                            return [2 /*return*/];
                    }
                });
            }); },
        });
    }, [
        libraryId,
        saveMutation,
        selectedType,
        singleSubject,
        singleBody,
        pluralSubject,
        pluralBody,
        pluralUsed,
        touched,
        currentTemplate,
        callout,
        formatMessage,
    ]);
    var handleResetConfirm = useCallback(function () {
        if (!libraryId)
            return;
        resetMutation.mutate(selectedType, {
            onSuccess: function () {
                setShowResetConfirm(false);
                callout === null || callout === void 0 ? void 0 : callout.sendCallout({
                    type: "success",
                    message: formatMessage({
                        id: "ui-br-legaldeposits.libraries.messageTemplates.reset.success",
                    }),
                });
            },
            onError: function () {
                setShowResetConfirm(false);
                callout === null || callout === void 0 ? void 0 : callout.sendCallout({
                    type: "error",
                    message: formatMessage({
                        id: "ui-br-legaldeposits.libraries.messageTemplates.reset.error",
                    }),
                });
            },
        });
    }, [libraryId, resetMutation, selectedType, callout, formatMessage]);
    var handlePreviewSingle = useCallback(function () {
        if (!libraryId)
            return;
        setSinglePreviewError(null);
        singlePreviewMutation.mutate({
            type: selectedType,
            variant: "SINGLE",
            subject: singleSubject,
            body: singleBody,
        }, {
            onError: function (error) { return __awaiter(void 0, void 0, void 0, function () {
                var message;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, extractErrorMessage(error)];
                        case 1:
                            message = _a.sent();
                            setSinglePreviewError(message !== null && message !== void 0 ? message : formatMessage({
                                id: "ui-br-legaldeposits.libraries.messageTemplates.preview.error",
                            }));
                            return [2 /*return*/];
                    }
                });
            }); },
        });
    }, [
        libraryId,
        singlePreviewMutation,
        selectedType,
        singleSubject,
        singleBody,
        formatMessage,
    ]);
    var handleHideSinglePreview = useCallback(function () {
        singlePreviewMutation.reset();
        setSinglePreviewError(null);
    }, [singlePreviewMutation]);
    var handlePreviewPlural = useCallback(function () {
        if (!libraryId)
            return;
        setPluralPreviewError(null);
        pluralPreviewMutation.mutate({
            type: selectedType,
            variant: "PLURAL",
            subject: pluralSubject,
            body: pluralBody,
        }, {
            onError: function (error) { return __awaiter(void 0, void 0, void 0, function () {
                var message;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, extractErrorMessage(error)];
                        case 1:
                            message = _a.sent();
                            setPluralPreviewError(message !== null && message !== void 0 ? message : formatMessage({
                                id: "ui-br-legaldeposits.libraries.messageTemplates.preview.error",
                            }));
                            return [2 /*return*/];
                    }
                });
            }); },
        });
    }, [
        libraryId,
        pluralPreviewMutation,
        selectedType,
        pluralSubject,
        pluralBody,
        formatMessage,
    ]);
    var handleHidePluralPreview = useCallback(function () {
        pluralPreviewMutation.reset();
        setPluralPreviewError(null);
    }, [pluralPreviewMutation]);
    var typeOptions = useMemo(function () {
        return MESSAGE_TEMPLATE_TYPES.map(function (type) { return ({
            value: type,
            label: formatMessage({ id: MESSAGE_TEMPLATE_TYPE_LABEL_IDS[type] }),
        }); });
    }, [formatMessage]);
    var placeholders = useMemo(function () {
        var _a;
        return ((_a = currentTemplate === null || currentTemplate === void 0 ? void 0 : currentTemplate.allowedPlaceholders) !== null && _a !== void 0 ? _a : NO_PLACEHOLDERS).map(function (token) {
            var descriptionId = findPlaceholderDescriptionId(token, messages);
            return {
                token: token,
                description: descriptionId
                    ? formatMessage({ id: descriptionId })
                    : placeholderToken(token),
            };
        });
    }, [currentTemplate, messages, formatMessage]);
    var isPeriodicalType = selectedType.startsWith("PERIODICAL_");
    var singleAccordionLabel = formatMessage({
        id: !pluralUsed
            ? "ui-br-legaldeposits.libraries.messageTemplates.accordion.onlyVariant"
            : isPeriodicalType
                ? "ui-br-legaldeposits.libraries.messageTemplates.accordion.singleIssue"
                : "ui-br-legaldeposits.libraries.messageTemplates.accordion.single",
    });
    var pluralAccordionLabel = formatMessage({
        id: isPeriodicalType
            ? "ui-br-legaldeposits.libraries.messageTemplates.accordion.pluralIssue"
            : "ui-br-legaldeposits.libraries.messageTemplates.accordion.plural",
    });
    var dialogTitle = libraryName
        ? formatMessage({
            id: "ui-br-legaldeposits.libraries.messageTemplates.dialog.titleWithLibrary",
        }, { libraryName: libraryName })
        : formatMessage({
            id: "ui-br-legaldeposits.libraries.messageTemplates.dialog.title",
        });
    var copyLabel = formatMessage({
        id: "ui-br-legaldeposits.libraries.messageTemplates.placeholders.copy",
    });
    var copiedLabel = formatMessage({
        id: "ui-br-legaldeposits.libraries.messageTemplates.placeholders.copied",
    });
    var hidePreviewLabel = formatMessage({
        id: "ui-br-legaldeposits.libraries.messageTemplates.button.hidePreview",
    });
    var discardTextIds = DISCARD_CONFIRM_TEXT_IDS[(_d = pendingDiscard === null || pendingDiscard === void 0 ? void 0 : pendingDiscard.kind) !== null && _d !== void 0 ? _d : "switchType"];
    var footer = (React.createElement(ModalFooter, null,
        React.createElement(Button, { buttonStyle: "primary", onClick: handleSave, disabled: !isDirty || saveMutation.isLoading }, formatMessage({
            id: "ui-br-legaldeposits.libraries.messageTemplates.footer.save",
        })),
        (currentTemplate === null || currentTemplate === void 0 ? void 0 : currentTemplate.source) === "LIBRARY" && (React.createElement(Button, { onClick: function () { return setShowResetConfirm(true); }, disabled: resetMutation.isLoading }, formatMessage({
            id: "ui-br-legaldeposits.libraries.messageTemplates.footer.resetToSystem",
        }))),
        React.createElement(Button, { onClick: onClose }, formatMessage({
            id: "ui-br-legaldeposits.libraries.messageTemplates.footer.close",
        }))));
    return (React.createElement(Modal, { open: open, label: dialogTitle, onClose: onClose, size: "large", footer: footer },
        templatesQuery.isLoading ? (React.createElement(Loading, null)) : templatesQuery.isError ? (React.createElement(MessageBanner, { type: "error" }, formatMessage({
            id: "ui-br-legaldeposits.libraries.messageTemplates.error.loadFailed",
        }))) : (React.createElement(React.Fragment, null,
            React.createElement(Label, { htmlFor: "message-template-type-select" }, formatMessage({
                id: "ui-br-legaldeposits.libraries.messageTemplates.field.type",
            })),
            React.createElement("div", { className: styles.typeRow },
                React.createElement(Select, { id: "message-template-type-select", dataOptions: typeOptions, value: selectedType, onChange: function (e) {
                        return handleTypeSelect(e.target.value);
                    }, marginBottom0: true }),
                currentTemplate && (React.createElement("span", { className: currentTemplate.source === "LIBRARY"
                        ? "".concat(styles.badge, " ").concat(styles.badgeLibrary)
                        : "".concat(styles.badge, " ").concat(styles.badgeSystem) }, formatMessage({
                    id: currentTemplate.source === "LIBRARY"
                        ? "ui-br-legaldeposits.libraries.messageTemplates.source.library"
                        : "ui-br-legaldeposits.libraries.messageTemplates.source.system",
                })))),
            React.createElement("div", { className: styles.placeholdersRow },
                React.createElement("span", { className: styles.placeholdersLabel }, formatMessage({
                    id: "ui-br-legaldeposits.libraries.messageTemplates.placeholders.label",
                })),
                placeholders.map(function (_a) {
                    var _b;
                    var token = _a.token, description = _a.description;
                    return (React.createElement(PlaceholderChip, { key: token, token: token, description: description, copyLabel: copyLabel, copiedLabel: copiedLabel, emptyHint: (_b = emptyHintByPlaceholder.get(token)) !== null && _b !== void 0 ? _b : null }));
                })),
            libraryId && (React.createElement(EmptyPlaceholderBanners, { libraryId: libraryId, usedEmptyPlaceholders: usedEmptyPlaceholders, onOpenLibraryEdit: handleOpenLibraryEdit })),
            pluralUsed && (React.createElement(VariantInfoNote, { singleLabel: singleAccordionLabel, pluralLabel: pluralAccordionLabel, isPeriodicalType: isPeriodicalType })),
            onlyCustomVariant && (React.createElement(OnlyCustomVariantBanner, { customVariant: onlyCustomVariant, singleLabel: singleAccordionLabel, pluralLabel: pluralAccordionLabel, isPeriodicalType: isPeriodicalType })),
            saveErrorMessage && (React.createElement(MessageBanner, { type: "error" }, saveErrorMessage)),
            React.createElement(AccordionSet, null,
                React.createElement(VariantEditor, { accordionId: "message-template-single", accordionLabel: React.createElement(VariantAccordionLabel, { label: singleAccordionLabel, variant: "SINGLE", source: currentTemplate === null || currentTemplate === void 0 ? void 0 : currentTemplate.singleSource, updatedAt: currentTemplate === null || currentTemplate === void 0 ? void 0 : currentTemplate.singleUpdatedAt }), subjectLabel: formatMessage({
                        id: "ui-br-legaldeposits.libraries.messageTemplates.field.subject",
                    }), bodyLabel: formatMessage({
                        id: "ui-br-legaldeposits.libraries.messageTemplates.field.body",
                    }), subject: singleSubject, body: singleBody, onSubjectChange: handleSingleSubjectChange, onBodyChange: handleSingleBodyChange, onPreview: handlePreviewSingle, onHidePreview: handleHideSinglePreview, previewLabel: formatMessage({
                        id: "ui-br-legaldeposits.libraries.messageTemplates.button.preview",
                    }), hidePreviewLabel: hidePreviewLabel, isPreviewLoading: singlePreviewMutation.isLoading, previewResult: (_e = singlePreviewMutation.data) !== null && _e !== void 0 ? _e : null, previewError: singlePreviewError, open: accordionOpen.single, onToggle: function () {
                        return setAccordionOpen(function (prev) { return (__assign(__assign({}, prev), { single: !prev.single })); });
                    } }),
                pluralUsed && (React.createElement(VariantEditor, { accordionId: "message-template-plural", accordionLabel: React.createElement(VariantAccordionLabel, { label: pluralAccordionLabel, variant: "PLURAL", source: currentTemplate === null || currentTemplate === void 0 ? void 0 : currentTemplate.pluralSource, updatedAt: currentTemplate === null || currentTemplate === void 0 ? void 0 : currentTemplate.pluralUpdatedAt }), subjectLabel: formatMessage({
                        id: "ui-br-legaldeposits.libraries.messageTemplates.field.subject",
                    }), bodyLabel: formatMessage({
                        id: "ui-br-legaldeposits.libraries.messageTemplates.field.body",
                    }), subject: pluralSubject, body: pluralBody, onSubjectChange: handlePluralSubjectChange, onBodyChange: handlePluralBodyChange, onPreview: handlePreviewPlural, onHidePreview: handleHidePluralPreview, previewLabel: formatMessage({
                        id: "ui-br-legaldeposits.libraries.messageTemplates.button.preview",
                    }), hidePreviewLabel: hidePreviewLabel, isPreviewLoading: pluralPreviewMutation.isLoading, previewResult: (_f = pluralPreviewMutation.data) !== null && _f !== void 0 ? _f : null, previewError: pluralPreviewError, open: accordionOpen.plural, onToggle: function () {
                        return setAccordionOpen(function (prev) { return (__assign(__assign({}, prev), { plural: !prev.plural })); });
                    } }))))),
        React.createElement(ConfirmationModal, { open: showResetConfirm, heading: formatMessage({
                id: "ui-br-legaldeposits.libraries.messageTemplates.reset.confirm.heading",
            }), message: formatMessage({
                id: "ui-br-legaldeposits.libraries.messageTemplates.reset.confirm.message",
            }), confirmLabel: formatMessage({
                id: "ui-br-legaldeposits.libraries.messageTemplates.reset.confirm.button",
            }), onConfirm: handleResetConfirm, onCancel: function () { return setShowResetConfirm(false); } }),
        React.createElement(ConfirmationModal, { open: pendingDiscard !== null, heading: formatMessage({
                id: "ui-br-legaldeposits.libraries.messageTemplates.discard.confirm.heading",
            }), message: formatMessage({ id: discardTextIds.message }), confirmLabel: formatMessage({ id: discardTextIds.button }), onConfirm: confirmDiscard, onCancel: cancelDiscard })));
};
